import { render, staticRenderFns } from "./acceptsHome.vue?vue&type=template&id=a5821aa4&scoped=true&"
import script from "./acceptsHome.vue?vue&type=script&lang=js&"
export * from "./acceptsHome.vue?vue&type=script&lang=js&"
import style0 from "./acceptsHome.vue?vue&type=style&index=0&id=a5821aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5821aa4",
  null
  
)

export default component.exports